/* tslint:disable */
type TransactionType =
  'SELL' |
  'BUY' |
  'OTHER';
module TransactionType {
  export const SELL: TransactionType = 'SELL';
  export const BUY: TransactionType = 'BUY';
  export const OTHER: TransactionType = 'OTHER';
  export function values(): TransactionType[] {
    return [
      SELL,
      BUY,
      OTHER
    ];
  }
}

export { TransactionType }